import { Box, HStack, Image, Text, VStack } from "native-base";
import CustomButton from "../../../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import MobileHeader from "../../../../layout/header/mobileHeader";
import "./style.css";

const MobileLandingPageBanner = ({ openModal }) => {
  function bannerText() {
    return (
      <VStack alignItems={"center"} justifyContent={"center"} px={4}>
        <Text
          fontSize={"24px"}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          pt={2}
          textAlign={"center"}
        >
          Welcome to ABG MICE & Events
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          textAlign={"center"}
          mb={4}
        >
          This is a all in one platform where you can view all your events and
          MICE.
        </Text>
        <CustomButton
          onPress={() => {
            openModal();
          }}
          text="Raise Request"
          width="fit-content"
          py="10px"
        />
      </VStack>
    );
  }
  return (
    <>
      <MobileHeader showTabs={true} />
      <div className="landing-page-banner-container">
        <HStack flex={1} w="100%" h="100%" direction={"column"}>
          <Box w={"100%"} alignItems={"center"} pt={5}>
            <Image
              source={{
                uri: require("../../../../utils/quickLinkImages/landing-page-banner.png"),
              }}
              alt="image"
              width="200px"
              minH="180px"
            />
          </Box>
          <Box w={"100%"} pt={6} pb={"2rem"}>
            {bannerText()}
          </Box>
        </HStack>
      </div>
    </>
  );
};

export default MobileLandingPageBanner;
